// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyProps } from "@insite/mobius/Typography";
import { addressInfoDisplayStyles } from "@keller/Overrides/Components/AddressInfoDisplay";
import { fontConfig } from "@keller/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

const addressInfoTypographyStyle: TypographyProps = {
    size: 12,
    as: "p",
    css: css`
        letter-spacing: 0;
        line-height: 18px;
    `,
};

addressInfoDisplayStyles.wrapper = {
    css: css`
        font-style: normal;
        width: 100%;
    `,
};

addressInfoDisplayStyles.customerNameText = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.attentionText = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.companyNameText = {
    as: "p",
    weight: fontConfig.weight.bold,
    size: 14,
    transform: "capitalize",
    css: css`
        letter-spacing: 0;
        line-height: 19px;
        margin-bottom: 8px;

        @media print {
            font-size: 12px;
            line-height: 18px;
            margin-bottom: 4px;
        }
    `,
};

addressInfoDisplayStyles.address1Text = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.address2Text = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.address3Text = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.address4Text = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.cityStatePostalCodeText = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.countryText = {
    ...addressInfoTypographyStyle,
};

addressInfoDisplayStyles.phoneText = {
    ...mergeWithCss(addressInfoTypographyStyle, {
        css: css`
            margin-top: 8px;
        `,
    }),
};

addressInfoDisplayStyles.emailText = {
    ...mergeWithCss(addressInfoTypographyStyle, {
        css: css`
            margin-top: 8px;
        `,
    }),
};

addressInfoDisplayStyles.faxText = {
    ...mergeWithCss(addressInfoTypographyStyle, {
        css: css`
            margin-top: 8px;
        `,
    }),
};

addressInfoDisplayStyles.defaultLabel = {
    size: 10,
    css: css`
        display: block;
        letter-spacing: 0;
        line-height: 15px;
        margin-bottom: 4px;
    `,
};

addressInfoDisplayStyles.headingWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            display: block;
        }
    `,
};

addressInfoDisplayStyles.accountNumberText = {
    as: "p",
    weight: fontConfig.weight.bold,
    size: 14,
    css: css`
        line-height: 19px;
        margin-bottom: 8px;
    `,
};
